import { apiWeeklyWeek } from "@/request/api";
import { ref, computed, watch } from "vue";
import useDateStore from "@/store/modules/useDate";

export default ({ change, callback }) => {
    const dateStore = useDateStore();
    const weekDict = ref([]); // 周字典
    const week = ref(localStorage.getItem("week") || "");
    const timeRank = computed(() => {
        let startTime = "",
            endTime = "";
        const obj = weekDict.value.find((item) => item.id === week.value);
        if (obj) {
            // 如果没有选择周
            startTime = obj.startTime;
            endTime = obj.endTime;
        } else if (dateStore.year && !dateStore.month) {
            // 如果只有年份
            startTime = dateStore.year + "-01-01";
            endTime = dateStore.year + "-12-31";
        } else if (dateStore.year && dateStore.month) {
            // 如果有年份和月份
            startTime = dateStore.year + "-" + dateStore.month.toString().padStart(2, "0") + "-01";
            // 获取这个月的最后一天
            const lastDay = new Date(dateStore.year, dateStore.month, 0).getDate();
            endTime = dateStore.year + "-" + dateStore.month.toString().padStart(2, "0") + "-" + lastDay.toString().padStart(2, "0");
        }
        return {
            startTime,
            endTime,
        };
    });

    // 根据年月过滤周字典
    function filterWeekDict(arr) {
        const year = dateStore.year;
        const month = dateStore.month;
        let ym = `${year}`;
        if (month) {
            ym += "-";
            ym += month.toString().padStart(2, "0");
        }
        return arr.filter((item) => {
            return item.startTime.startsWith(ym) || item.endTime.startsWith(ym);
        });
    }

    // 获取周字典
    async function setWeekDict() {
        const { data } = await apiWeeklyWeek();
        weekDict.value = data || [];
        weekDict.value = weekDict.value.reverse();
        weekDict.value = weekDict.value.map((item) => {
            const startTimeArr = item.startTime.split("-");
            const endTimeArr = item.endTime.split("-");
            item.label = `${item.cycle} (${startTimeArr[1]}.${startTimeArr[2]}-${endTimeArr[1]}.${endTimeArr[2]})`;
            return item;
        });
        weekDict.value = filterWeekDict(weekDict.value); // 根据年月过滤周字典
        if (!week.value && weekDict.value.length) {
            week.value = weekDict.value[0]?.id || "";
            changeWeek();
            return;
        }
        callback();
    }

    // 周改变
    function changeWeek() {
        localStorage.setItem("week", week.value || "");
        if (timeRank.value.startTime && timeRank.value.endTime) {
            localStorage.setItem("startTime", timeRank.value.startTime);
            localStorage.setItem("endTime", timeRank.value.endTime);
        } else {
            localStorage.removeItem("startTime");
            localStorage.removeItem("endTime");
        }
        change();
    }

    // 年月改变
    watch(
        () => [dateStore.year, dateStore.month],
        () => {
            // 清空选中周
            week.value = "";
            localStorage.removeItem("week");
            localStorage.removeItem("startTime");
            localStorage.removeItem("endTime");
            weekDict.value = [];
            setWeekDict(); // 重新获取周字典
        },
    );

    setWeekDict();

    return { weekDict, week, timeRank, changeWeek };
};
